import { FunctionComponent } from 'react';
import classNames from 'clsx';
import { Shimmer } from '../Shimmer/Shimmer';
import { RailBrand } from './components';
import { RAIL_ASIDE_STYLE, railAsideClassName } from './Rail';
import { useRailCollapsed } from './useRailCollapsed';

// Anchos de las etiquetas: variados para que no se lea como una tabla.
const ROWS = [62, 48, 70, 54, 66, 44];

/**
 * Rail provisional mientras la sesión no llegó. Mismo `<aside>`, mismo ancho
 * (colapsado o no, según la ruta y la preferencia guardada) y mismo alto que el
 * rail real: cuando llega la sesión solo cambia lo de adentro y el contenido no
 * se corre. Antes el rail directamente no estaba y aparecía de golpe.
 */
export const RailSkeleton: FunctionComponent = () => {
  const { collapsed } = useRailCollapsed();

  return (
    <aside data-app-rail style={RAIL_ASIDE_STYLE} className={railAsideClassName(collapsed)}>
      <RailBrand href="/" collapsed={collapsed} />
      <Shimmer
        className={classNames('shrink-0', collapsed ? 'mx-auto h-9 w-9' : 'h-[38px]')}
        rounded="rounded-lg"
      />

      <div className="mt-2.5 flex min-h-0 flex-1 flex-col overflow-hidden py-1.5">
        {ROWS.map((width, i) => (
          <div
            key={i}
            className={classNames(
              'my-px flex items-center',
              collapsed ? 'min-h-[38px] justify-center p-px' : 'min-h-[34px] gap-[11px] px-1.5 py-1'
            )}
          >
            <Shimmer
              className={collapsed ? 'h-9 w-9 shrink-0' : 'h-[26px] w-[26px] shrink-0'}
              rounded="rounded-lg"
            />
            {!collapsed && <Shimmer className="h-3" style={{ width: `${width}%` }} />}
          </div>
        ))}
      </div>

      <div
        className={classNames(
          'mt-1.5 flex w-full items-center rounded-xl',
          collapsed ? 'justify-center px-0 py-2.5' : 'gap-[11px] bg-[rgba(var(--f-ink-rgb),0.04)] p-2.5'
        )}
      >
        <Shimmer className="h-[34px] w-[34px] shrink-0" rounded="rounded-full" />
        {!collapsed && (
          <span className="flex min-w-0 flex-1 flex-col gap-1.5">
            <Shimmer className="h-3 w-3/4" />
            <Shimmer className="h-2.5 w-1/2" />
          </span>
        )}
      </div>
    </aside>
  );
};
